<template>
    <div class="signup-page">
        <div class="container">
            <div v-if="errors.length > 0"
                 style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
                </ul>
            </div>
            <div v-if="successes.length > 0"
                 style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
                </ul>
            </div>
            <div class="row justify-content-between">
                <div class="col-md-8">
                    <div class="row gx-5 justify-content-between">
                        <div class="col-md-6 col-sm-12">
                            <h1>{{ $t('reset_password') }}</h1>

                            <div class="forms-style-1">

                                <div class="row">
                                    <div class="col-md-12">
                                        <form :action="$store.state.hrefPrefix + '/forget-password'" method="post"
                                              @submit.prevent="" ref="resetLink">
                                            <div class="row justify-content-between">
                                                <input type="hidden" name="_token" :value="csrf">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="input-row">
                                                        <label>{{ $t('email') }}</label>
                                                        <input type="email" :placeholder="$t('email')" name="email" required/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-12">
                                                    <div class="submit-btn">
                                                        <div v-if="isLoading">
                                                            <p>{{ $t('Submitting') }}</p>
                                                        </div>
                                                        <input v-if="!isLoading" class="g-recaptcha"
                                                               data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                               data-callback="submitResetLink" type="button"
                                                               :value="$t('submit')"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

window.flashMessages = {
    success: "{!! session('success') !!}",
    error: "{!! session('error') !!}"
};
let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
} else if (typeof flashMessages !== 'undefined' && flashMessages.success) {
    successes = [flashMessages.success];
}


export default {
    name: "ForgetPasswordPage",
    components: {},
    props: {},

    data() {
        return {
            isLoading: false,
            errors: errors,
            successes: successes,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        submitResetLink(response) {
            this.isLoading = true;
            const form = this.$refs.resetLink;
            form.submit();
        },
    },
    mounted() {
        window.submitResetLink = this.submitResetLink;
    }
}
</script>

<style scoped>
.btn-165 {
    padding: 10px 25px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    border-radius: 0.5rem;
    border: 1px solid #bebebe;
    gap: 10px;
    color: #414141;
    background: #fff;
    font-family: Arial, Helvetica, sans-serif;
    cursor: pointer;
    text-decoration: none;
    user-select: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    /*** full width block ***/
    /* width: 100%; */
}

.btn-165 svg {
    height: 24px;
}

.btn-165:hover {
    border: solid 1px #464545;
}

.btn-165:active {
    margin-top: 1px;
}

/*** disabled style ***/
.btn-165:disabled {
    pointer-events: none;
    opacity: .65;
    color: #7e7e7e;
    background: #dcdcdc;
    box-shadow: none;
    text-shadow: none;
}


</style>
